<router-outlet></router-outlet>

<div @fadeIn @fadeOut *ngIf="isDragging" class="drag-event custom-center">
  <div class="text-center">
    <i class="pi pi-upload" style="color: white; font-size: 4rem;"></i>
    <p style="color: white; font-size: 2rem;">Suelte para cargar el archivo</p>
  </div>
</div>

<div class="env-banner dev" *ngIf="!environment.production && !environment.testing">
  <span>🚧 ENTORNO DESARROLLO</span>
</div>

<div class="env-banner test" *ngIf="!environment.production && environment.testing">
  <span>🧪 ENTORNO TESTING</span>
</div>

<!-- Modal para actualización del Service Worker -->
<p-confirmDialog key="updateDialog" [style]="{ width: '380px' }" styleClass="update-dialog">
</p-confirmDialog>